import { generalCountConfig, StatTableConfig } from "./configConstructor";

export default new StatTableConfig({
  type: "sms",
  counts: {
    sent: {
      label: 'СМС отправлено',
      ...generalCountConfig
    },
    delivered: {
      label: 'Доставлено',
      ...generalCountConfig
    },
    undelivered: {
      label: 'Не доставлено',
      ...generalCountConfig
    }
  },
  charts: {
    delivered: { color: 'green' },
    undelivered: { color: 'orange' }
  }
});
